<div class="footer">
  <div class="container py-3">
    <div class="frame-42 row row-cols-md-3 row-cols-auto row-cols-sm-1 pb-5">
      <div class="logo">
        <img width="109" height="51" src="assets/logo/logo-white.svg" alt="Logo TDM">
        <a href="https://www.opinionsystem.fr/fr-fr/search/group/2040" target="_blank" rel="noopener noreferrer" title="Consulter nos avis Opinion System" class="d-inline-block mt-2">
          <img src="assets/svg/notation-opinion-system.svg" alt="Avis Opinion System" style="height: 24px; width: auto;" />
        </a>
      </div>
      <div class="contact">
        <h5>
          POUR TOUTE DEMANDE D’INFORMATIONS
        </h5>
        <p style="font-size: 16px;">
          Contactez-nous au <span class="fw-semibold">01 30 46 69 70</span>
        </p>
        <div class="menu-cta-row flex-wrap">
          <button [routerLink]="['/contact']" fragment="Nous-contacter" type="button" class="btn btn-outlined mx-1">
            Nous contacter
          </button>
<!--          <button [routerLink]="['/amis-tdm/liste']" type="button" class="btn btn-gold mx-1">-->
<!--            Trouver mon Conseiller-->
<!--          </button>-->
        </div>
      </div>
      <div class="faq">
        <h5 class="headline text-uppercase">
          <a [routerLink]="['/faq-the-door-man.html']" routerLinkActive="router-link-active"
            class="link-list-item fw-semibold pb-1">
            Questions fréquentes
          </a>
        </h5>
        <div>
          Une question ? Nous avons la réponse !
        </div>
        <div class="link-list link-list-2-column pt-3">
          <a [routerLink]="['/faq-the-door-man.html']" fragment="pour-les-vendeurs"
            routerLinkActive="router-link-active" class="link-list-item fw-semibold pb-1">
            Vendeurs
          </a>
          <a [routerLink]="['/faq-the-door-man.html']" class="link-list-item fw-semibold pb-1">
            Locataires
          </a>
          <a [routerLink]="['/faq-the-door-man.html']" fragment="pour-les-acheteurs"
            class="link-list-item fw-semibold pb-1">
            Acquéreurs
          </a>
          <a [routerLink]="['/faq-the-door-man.html']" fragment="pour-les-partenaires"
            class="link-list-item fw-semibold pb-1">
            Partenaires
          </a>
          <a [routerLink]="['/faq-the-door-man.html']" fragment="by-tdm"
            class="link-list-item fw-semibold pb-1">
            By TDM
          </a>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="copyright">
        © 2023 THE DOOR MAN
        <img width="52" height="41" src="assets/logo/fnaim.svg" class="mx-2" alt="Logo FNAIM">
      </div>
      <div class="link-list">
        <a [routerLink]="['/nos-concessions/honoraires']" class="link-list-item mx-2">Nos honoraires </a>
        <a [routerLink]="['/charte-protection-données.html']" class="link-list-item mx-2">Protection des données personnelles </a>
        <a [routerLink]="['/mentions-legales-the-door-man.html']" class="link-list-item mx-2">Mentions légales</a>
        <div class="cookie-disclaimer" *ngIf="displayCookie">
          <div class="container">
            <div class="row">
              <div class="col-md-11">
                <div class="cookie-content">
                  <div> Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre site.
                    La liste, la gestion et le paramétrage de ceux-ci sont indiqués dans notre
                    <a [routerLink]="['/charte-protection-données.html']" style="display: contents; text-decoration: underline;
                    ">Charte de Protection des Données
                      Personnelles</a>
                  </div>
                  <button (click)="acceptCookies()" class="accept-button">ok</button>
                </div>
              </div>
<!--              <div class="col-md-1">-->
<!--                &lt;!&ndash; <a [routerLink]="['/mentions-legales-the-door-man.html']" class="link-list-item mx-2">Mentions légales</a> &ndash;&gt;-->
<!--                <button (click)="acceptCookies()" class="close-button">x</button>-->
<!--              </div>-->
            </div>
          </div>

        </div>
      </div>
      <div class="social">
        <span class="mx-2 fw-semibold">
          Nos réseaux sociaux
        </span>
        <a href="https://www.facebook.com/thedoormanfrance/" target="_blank">
          <img width="37" height="36" src="assets/logo/fb.svg" class="mx-1" alt="Facebook The Door Man"></a>
        <a href="https://www.linkedin.com/company/the-door-man/" target="_blank">
          <img width="37" height="36" src="assets/logo/linkedin.svg" class="mx-1" alt="Linkedin The Door Man"></a>
        <a href="https://www.instagram.com/thedoormanfrance/" target="_blank">
          <img width="37" height="36" src="assets/logo/insta.svg" class="mx-1" alt="Instagram The Door Man"></a>
      </div>
    </div>
  </div>
</div>

<ngbd-toast-global></ngbd-toast-global>
